import { ChangeEvent, useCallback } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import L from "@/translations";
import { FilterOption } from "@/types/FilterOptions";
import { Checkbox } from "@components/Field";
import { ListItem } from "@components/List";

const TOGGLE_ALL_THRESHOLD = 3;

const CheckboxSelect = ({
  options = [],
  name,
}: {
  options: FilterOption[];
  name: string;
}) => {
  const { register, setValue } = useFormContext();
  const value = useWatch({ name });

  // consts used to disable the button or show the only available option
  const showToggleAll = options.length > TOGGLE_ALL_THRESHOLD;
  const hasOneOption = options.length === 1;

  const toggleAll = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { checked } = e.target;
      if (!checked) {
        setValue(name, undefined);
      } else {
        setValue(
          name,
          options.map(([v]) => v)
        );
      }
    },
    [options, setValue, name]
  );

  if (hasOneOption) {
    const [value, label] = options[0];
    return <Checkbox disabled checked label={label || value} />;
  }

  return (
    <>
      {showToggleAll && (
        <ListItem component="span" passPadding alignContent>
          <Checkbox
            onChange={toggleAll}
            checked={value?.length === options.length}
            label={L.MENTIONS_QUERYBUILDER_FILTER_SELECT_ALL}
          />
        </ListItem>
      )}

      {options.map(([v, k], i) => (
        <ListItem key={i} component="span" passPadding alignContent>
          <Checkbox
            type="checkbox"
            // Warning! nothing here will update until subscriptions are extended or removed. Put here for performance reasons
            {...register(name)}
            value={v}
            label={k || v} // default to showing the value if there's no label
          />
        </ListItem>
      ))}
    </>
  );
};

export default CheckboxSelect;
